import React from "react";
import { Box } from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";

/** Page chrome for content pages (Header + Footer). The funnel uses its own
 *  minimal chrome (StepLayout) and is intentionally not wrapped. */
export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <Box sx={{ minHeight: "100dvh", display: "flex", flexDirection: "column", bgcolor: "background.default" }}>
      <Header />
      <Box component="main" sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {children}
      </Box>
      <Footer />
    </Box>
  );
}
